import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const intro = getSharedAsset('indy-intro.mp4', 'demos', 'videos')
const video = getSharedAsset('indy.mp4', 'demos', 'videos')
const monolith = getSharedAsset('indy.png', 'demos', 'monoliths')
const poster = getSharedAsset('indy.png', 'demos', 'posters')
const nextDemoThumbnail = getSharedAsset('mec-explainer.png', 'demos', 'thumbnails')

export const indy: IDemo = {
  id: DemoIds.indy,
  type: E3DDemoNameVals.indy,
  intro,
  video,
  monolith,
  poster,
  end: {
    header: 'Into the heart of the action.',
    body: 'Verizon is dedicated to bringing immersive and improved sports experiences to fans around the world.',
    nextDemoText: 'MEC Explainer',
    nextDemoId: DemoIds.mecExplainer,
    nextDemoThumbnail,
    previousDemoId: DemoIds.shotTracker
  }
}
